import { identity } from "lodash";
import { i18n, i18nText } from "@next-core/i18n";
import { widgetI18nFactory } from "./WidgetI18n.js";
import { getReadOnlyProxy } from "../proxyFactories.js";
import { getCssPropertyValue, getTheme } from "../../themeAndMode.js";
import { getBasePath } from "../../getBasePath.js";
import { getI18nNamespace } from "../registerAppI18n.js";
import { hooks } from "../Runtime.js";
import { isolatedFunctionRegistry } from "./IsolatedFunctions.js";
// `GeneralGlobals` are globals which are page-state-agnostic,
// thus they can be used both in storyboard expressions and functions.
export function getGeneralGlobals(attemptToVisitGlobals, options) {
  const globalVariables = {};
  for (const variableName of attemptToVisitGlobals) {
    const variable = getIndividualGlobal(variableName, options);
    if (variable !== undefined) {
      globalVariables[variableName] = variable;
    }
  }
  return globalVariables;
}
function getIndividualGlobal(variableName, _ref) {
  var _hooks$images, _hooks$images2, _hooks$checkPermissio;
  let {
    collectCoverage,
    widgetId,
    widgetVersion,
    isolatedRoot,
    app,
    appendI18nNamespace,
    storyboardFunctions,
    isStoryboardFunction
  } = _ref;
  switch (variableName) {
    case "BASE_URL":
      return collectCoverage ? "/next" : getBasePath().replace(/\/$/, "");
    case "FN":
      return isolatedRoot ? isolatedFunctionRegistry.get(isolatedRoot) : storyboardFunctions;
    case "IMG":
      return collectCoverage ? fakeImageFactory() : widgetId ? hooks === null || hooks === void 0 || (_hooks$images = hooks.images) === null || _hooks$images === void 0 ? void 0 : _hooks$images.widgetImagesFactory(widgetId, widgetVersion) : hooks === null || hooks === void 0 || (_hooks$images2 = hooks.images) === null || _hooks$images2 === void 0 ? void 0 : _hooks$images2.imagesFactory(app.id, app.isBuildPush, app.currentVersion);
    case "I18N":
      return collectCoverage ? identity : widgetId ? widgetI18nFactory(widgetId) : i18n.getFixedT(null, [appendI18nNamespace, getI18nNamespace("app", app.id)].filter(Boolean));
    case "I18N_TEXT":
      return collectCoverage ? fakeI18nText : i18nText;
    case "LANGUAGE":
      {
        return collectCoverage ? "zh" : i18n.language || "zh";
      }
    case "PERMISSIONS":
      return getReadOnlyProxy({
        check: collectCoverage ? fakeCheckPermissions : hooks === null || hooks === void 0 || (_hooks$checkPermissio = hooks.checkPermissions) === null || _hooks$checkPermissio === void 0 ? void 0 : _hooks$checkPermissio.checkPermissions
      });
    case "THEME":
      return getReadOnlyProxy({
        getTheme: collectCoverage ? () => "light" : getTheme,
        getCssPropertyValue: collectCoverage ? () => "" : getCssPropertyValue
      });
    case "console":
      return isStoryboardFunction ? getReadOnlyProxy(console) : undefined;
    case "location":
      return collectCoverage ? {
        href: "http://localhost:3000/functions/test",
        origin: "http://localhost:3000",
        host: "localhost:3000",
        hostname: "localhost"
      } : {
        href: location.href,
        origin: location.origin,
        host: location.host,
        hostname: location.hostname
      };
  }
}
function fakeI18nText(data) {
  return data === null || data === void 0 ? void 0 : data.en;
}
function fakeImageFactory() {
  return {
    get(name) {
      return `mock/images/${name}`;
    }
  };
}
function fakeCheckPermissions() {
  return true;
}
//# sourceMappingURL=getGeneralGlobals.js.map